import { render, staticRenderFns } from "./BaAdminAuthorize.vue?vue&type=template&id=79b47551&"
import script from "./BaAdminAuthorize.vue?vue&type=script&lang=js&"
export * from "./BaAdminAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports